'use strict';

import React from 'react';
import {Link} from 'react-router';
import Dialog from 'material-ui/Dialog';
import DocumentTitle from 'react-document-title';
import * as Connections from "../../utils/Connections";
import { saveAs } from 'file-saver';
import GetInvoice from "../../components/GetInvoice";
import * as Cookies from "../../utils/Cookies";
import $ from 'jquery';
const modalStyle = {
    width: '80%',
    height: '90%;',
    maxWidth: 'none',
    maxHeight: 'none',
};
const styles = {
    marginSide:{
        marginLeft: '1em'
    }
};
class ViewBills extends React.Component {
    constructor(props) {
        super(props);
        this.state = props.temp;
        this.setState({
            open: false,
            profile:props.profile,
            paid:props.paid

        })
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleSendToEmail = this.handleSendToEmail.bind(this);

    }

    handleOpen(order,date) {
        this.setState({open: true, selectedOrder: order,date:date,mainKey:order[0].mainKey});
    }

    handleClose() {
        this.setState({open: false});
    }

    handleSendToEmail() {
        var sendData = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded'
            }),
            body: $.param({
                type: "createInvoice",
                token: Cookies.checkCookie("accessToken"),
                invoice:this.state.mainKey

            })
        };
        let self = this;
        fetch(Connections.getLinkLocation(), sendData)
            .then(response => response.blob())
            .then(blob => saveAs(blob, "KL" + self.state.mainKey + ".pdf"));
    }

    render() {
        const actions = [
            <button onClick={this.handleClose} className="uk-button uk-button-default " type="button">Cancel</button>,
            <button onClick={this.handleSendToEmail} style={styles.marginSide} className="uk-button uk-button-primary" type="button">Download PDF</button>
        ];
        return (
            <DocumentTitle title="Khula - Billing">
                <div >
                    <a href={"#" + this.state["key"]+this.state.paid} data-toggle="collapse" className="collapsed"
                       aria-expanded="false">
                        <div className="col-sm-12 col-xs-12 col-lg-12 col-md-12 marginInvoiceStyle" style={{
                            borderColor:"#959994",
                            borderStyle:"solid",
                            borderWidth:"1px"
                        }}>
                            <div className="wrapper uk-card uk-card-hover setBackgroundWhite">
                                <div className="card radius shadowDepth1">
                                    <div className="setToRight">
                                        <strong>{this.state["key"]}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                    <div id={this.state["key"]+this.state.paid} className="collapse" aria-expanded="false">
                        <table className="uk-table uk-table-middle uk-table-divider">
                            <thead>
                            <tr>
                                <th className="uk-width-small">Generated Date</th>
                                <th>Orders Number</th>
                                {/*<th>Produce Name</th>*/}
                                {/*<th>Description</th>*/}
                                {/*<th>Price (per Unit)</th>*/}
                                <th>Full Invoice</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state["data"].map((order, i) =>
                                <tr key={order.id}>
                                    <td>
                                        <p className="uk-text-meta uk-margin-remove-top">
                                            <time>{order.date}</time>
                                        </p>
                                    </td>
                                    <td>{order.data.length} Orders</td>
                                    {/*<td>{order.description}</td>*/}
                                    {/*<td>R {order.clientPrice} </td>*/}
                                    <td><a onClick={(e) => this.handleOpen(order.data,order.date)}
                                           className="uk-button uk-button-text">View</a></td>
                                </tr>
                            )}
                            </tbody>

                        </table>
                    </div>
                    <Dialog
                        actions={actions}
                        modal={false}
                        open={this.state.open}
                        onRequestClose={this.handleClose}
                        contentStyle={modalStyle}
                        autoScrollBodyContent={true}>
                        <div >
                            <GetInvoice temp={this.state} />
                        </div>
                    </Dialog>
                </div>
            </DocumentTitle>
        );
    }

}

export default ViewBills;



// WEBPACK FOOTER //
// ./src/pages/HopePageBabies/ViewBills.js